import { render, staticRenderFns } from "./StoppingOrderCommentModal.vue?vue&type=template&id=0edd4fb2&"
import script from "./StoppingOrderCommentModal.vue?vue&type=script&lang=js&"
export * from "./StoppingOrderCommentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports